/**
 * Codes upload script
 */
import Vue from 'vue/dist/vue';
import vue2Dropzone from 'vue2-dropzone/dist/vue2Dropzone';
import utils from './../utils';
import ui from './../ui';
import forms from './forms';

require('form-serializer/dist/jquery.serialize-object.min');

/**
 * Initialization of assets for all inputs
 * inside a container
 * @param {jQuery} $container
 */
const initializeContainer = function($container) {
    $container.find('[data-codes-upload]').each(function() {
        let $codesUploadContainer = $(this);
        if ($codesUploadContainer.hasClass('initialized')) {
            return;
        }

        let id = utils.uniqueID($codesUploadContainer);

        // Update the template to bind
        utils.vueBind($codesUploadContainer.find('[id], [name], [for]'), ['id', 'name', 'for']);
        let data      = $codesUploadContainer.data('codes-upload');
        data.widgetId = id;

        let vm = new Vue({
            el:         `#${id}`,
            components: {
                vueDropzone: vue2Dropzone,
            },
            data:       data,
            methods:    {
                onUploaded:  function(file, response) {
                    let $replacement = $(response);
                    let $element     = $(this.$el);
                    let $cardBody    = $element.closest('.card-body');
                    $cardBody.empty().append($replacement);
                    ui.initializeContainer($replacement);
                    forms.stopLoading($replacement);
                },
                onUpload:    function(file, xhr, formData) {
                    let $element     = $(this.$el);
                    let appendedData = $element.find('form').serializeObject();
                    utils.appendObject(formData, appendedData);
                    formData.delete('s3ObjectLocation');
                },
                submitCodes: function() {
                    this.$refs.codesDropzone.processQueue();
                    forms.startLoading($(this.$el));
                },
            },
            mounted:    function() {
                let $element = $(this.$el);
                ui.initializeContainer($element);
            },
            updated:    function() {
                let $element = $(this.$el);
                ui.initializeContainer($element);
            },
        });

        $codesUploadContainer.addClass('initialized').data('vm', vm);
    });
};

// Export initialization
export default {
    initializeContainer: initializeContainer,
};



// WEBPACK FOOTER //
// ./plugins/Admin/build/script/src/components/codes_upload.js